/** 签约记录中的合利宝支付渠道标识。 */
export function isHelibaoAgreement(agreement) {
  return agreement?.tradeType === "HlbYlPay";
}

/** 三层返回码均成功时，才使用合利宝返回的交易卡信息。 */
export function parseHelibaoAgreementStatus(response) {
  if (response?.code !== 200) {
    throw new Error(
      response?.content || response?.message || response?.msg || "合利宝详情查询失败",
    );
  }
  const result = response.data;
  if (result?.code !== "0000") {
    throw new Error(result?.message || "合利宝详情查询失败");
  }
  const detail = result.data;
  if (detail?.rt2_retCode !== "0000") {
    throw new Error(detail?.rt3_retMsg || "合利宝交易卡查询失败");
  }
  const cards = detail.rt5_bindCardList ?? [];
  if (
    !Array.isArray(cards) ||
    cards.some((card) => !card || typeof card !== "object" || Array.isArray(card))
  ) {
    throw new Error("合利宝交易卡信息格式异常");
  }
  return { ...detail, rt5_bindCardList: cards };
}
